module.exports = __webpack_public_path__ + "static/media/warning.498d4942.svg";